// extracted by mini-css-extract-plugin
export default {"radio":"radio_radio__YmD-k","marker":"radio_marker__av780","selectedCircle":"radio_selectedCircle__iR2uk","text":"radio_text__ItMiQ"};